import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import BoardThumbnail from "~/components/BoardThumbnail/BoardThumbnail";
import { getPreferenceImgixFit, useThumbnailPreference } from "~/hooks/useThumbnailPreference";
import { CentralizedBoardSelectors } from "~/store/centralizedBoard/selectors";
export const BoardGalleryCardThumbnail = (param)=>{
    let { board, height, sizes } = param;
    const { getPreference } = useThumbnailPreference();
    const boardId = useSelector(CentralizedBoardSelectors.boardId);
    const thumbnailPreference = useMemo(()=>getPreference(boardId), [
        boardId,
        getPreference
    ]);
    return /*#__PURE__*/ _jsx(BoardThumbnail, {
        board: board,
        objectFit: thumbnailPreference === "default" ? "cover" : "contain",
        imgixParams: {
            fit: getPreferenceImgixFit(thumbnailPreference)
        },
        height: height,
        sizes: sizes,
        width: "100%"
    });
};
